export const TEXT_GROUPS = [
  { id: "nav", label: "Menu e rodapé", items: [
    ["nav_home", "Menu: Início", "Início"],
    ["nav_news", "Menu: Novidades", "Novidades"],
    ["nav_rules", "Menu: Regras", "Regras"],
    ["nav_info", "Menu: Informações", "Informações"],
    ["nav_store", "Menu: Loja", "Loja"],
    ["nav_pricing", "Menu: Preçário", "Preçário"],
    ["footer_tagline", "Rodapé: frase (antes do código)", "Servidor de roleplay português. Código de ligação"],
    ["footer_discord", "Rodapé: ligação Discord", "Discord"],
    ["footer_store", "Rodapé: ligação loja", "Loja Tebex"],
    ["footer_copyright", "Rodapé: direitos (depois do ano)", "EDEN RP. Todos os direitos reservados."],
    ["footer_disclaimer", "Rodapé: aviso legal", "EDEN RP não está afiliado à Rockstar Games, Take-Two Interactive ou à Cfx.re."],
  ] },
  { id: "status", label: "Estado do servidor", items: [
    ["status_online", "Estado: online", "Online"],
    ["status_offline", "Estado: offline", "Offline"],
    ["status_checking", "Estado: a verificar", "A verificar…"],
    ["status_unavailable", "Estado: indisponível", "Estado indisponível"],
    ["status_players", "Rótulo jogadores", "Jogadores"],
    ["status_code", "Rótulo código", "Código"],
    ["status_staff", "Rótulo staff no Discord", "Staff no Discord"],
    ["status_error", "Erro API FiveM", "Não foi possível contactar a API do FiveM. Tentamos novamente em breve."],
    ["connect_prefix", "Dica de ligação (antes do código)", "ou escreve"],
    ["connect_suffix", "Dica de ligação (depois do código)", "na consola F8"],
    ["banner_title", "Aviso servidor voltou: título", "O servidor voltou a estar online."],
    ["banner_text", "Aviso servidor voltou: texto (depois de X de Y)", "jogadores na cidade. Entra agora."],
    ["banner_button", "Aviso servidor voltou: botão", "Jogar agora"],
  ] },
  { id: "home", label: "Página inicial", items: [
    ["city_eyebrow", "Etiqueta secção cidade", "A cidade"],
    ["history_eyebrow", "Gráfico: etiqueta", "Últimas 24 horas"],
    ["history_title", "Gráfico: título", "Jogadores na cidade"],
    ["history_now", "Gráfico: agora", "Agora"],
    ["history_peak", "Gráfico: pico", "Pico"],
    ["history_avg", "Gráfico: média", "Média"],
    ["gallery_eyebrow", "Galeria: etiqueta", "Galeria"],
    ["gallery_featured_label", "Galeria: selo do destaque", "Foto da semana"],
    ["gallery_featured_eyebrow", "Galeria: etiqueta do destaque", "A mais votada no Discord"],
    ["gallery_featured_fallback", "Galeria: título quando sem legenda", "Um momento da cidade escolhido pela comunidade"],
    ["latest_eyebrow", "Novidades na Home: etiqueta", "Novidades"],
    ["latest_title", "Novidades na Home: título", "Últimas da cidade"],
    ["latest_all", "Novidades na Home: ver todas", "Ver todas as novidades"],
    ["vip_title", "VIPs na Home: título", "VIPs do EDEN"],
    ["vip_text", "VIPs na Home: texto", "Um VIP diferente em destaque de cada vez que visitas. Todos permanentes, todos com benefícios no Discord e na cidade."],
    ["vip_all", "VIPs na Home: ver todos", "Ver todos os pacotes"],
    ["countdown_default", "Contador: título por omissão", "Contagem decrescente"],
  ] },
  { id: "news", label: "Página Novidades", items: [
    ["news_eyebrow", "Etiqueta", "Novidades"],
    ["news_title", "Título", "O que se passa na cidade"],
    ["news_text", "Texto", "Publicações reais dos canais oficiais do Discord, atualizadas automaticamente."],
    ["news_tab_updates", "Separador updates", "Updates"],
    ["news_tab_giveaways", "Separador giveaways", "Giveaways"],
    ["news_tab_events", "Separador eventos", "Eventos"],
    ["news_empty_title", "Sem publicações: título", "Ainda não há publicações nesta área."],
    ["news_empty_text", "Sem publicações: texto", "Assim que a staff publicar no Discord, aparece aqui automaticamente."],
    ["news_error", "Erro Discord", "De momento não conseguimos ligar ao Discord. Tenta mais tarde ou visita o servidor diretamente."],
    ["news_open_discord", "Botão abrir Discord", "Abrir Discord"],
  ] },
  { id: "rules", label: "Página Regras", items: [
    ["rules_eyebrow", "Etiqueta", "Regras"],
    ["rules_title", "Título", "Regulamento do EDEN RP"],
  ] },
  { id: "info", label: "Página Informações", items: [
    ["info_eyebrow", "Etiqueta", "Informações"],
    ["info_title", "Título", "Tudo o que precisas antes de entrar"],
    ["info_text", "Texto", "Guia essencial para novos e antigos cidadãos do EDEN."],
    ["staff_eyebrow", "Staff: etiqueta", "Staff"],
    ["staff_online_suffix", "Staff: contador online (depois do número)", "da staff online no Discord agora"],
    ["staff_note", "Staff: nota final", "Atualizado automaticamente a partir dos cargos e do estado online do Discord."],
  ] },
  { id: "store", label: "Página Loja", items: [
    ["store_payments", "Nota pagamentos", "Pagamentos processados exclusivamente pela Tebex."],
    ["catalog_eyebrow", "Catálogo: etiqueta", "Catálogo"],
    ["catalog_title", "Catálogo: título", "O que encontras na loja"],
    ["catalog_text", "Catálogo: texto", "Preços e pacotes lidos diretamente da loja Tebex. A compra é sempre concluída na Tebex."],
    ["group_vips", "Grupo VIPs", "VIPs permanentes"],
    ["group_others", "Grupo outros pacotes", "Pacotes de EDENS"],
    ["vip_spotlight", "Destaque: etiqueta", "VIP em destaque"],
    ["vip_other", "Destaque: botão outro", "Outro"],
    ["vip_open", "Destaque: ver na Tebex", "Ver na Tebex"],
  ] },
  { id: "pricing", label: "Página Preçário", items: [
    ["pricing_categories_label", "Etiqueta dos separadores", "Explora por categoria"],
    ["pricing_item_label", "Coluna: artigo", "Artigo / serviço"],
    ["pricing_value_label", "Coluna: preço", "Preço"],
    ["pricing_pending", "Preço por preencher", "A definir"],
    ["pricing_empty_title", "Sem artigos: título", "Preçário em preparação"],
    ["pricing_empty_text", "Sem artigos: texto", "Os artigos e preços desta área serão publicados em breve. Volta para descobrir as novidades."],
  ] },
  { id: "community", label: "Comunidade Discord", items: [
    ["community_state", "Rótulo estado", "Estado"],
    ["community_online", "Rótulo membros online", "Membros online"],
    ["community_active", "Estado ativo", "Ativo"],
    ["community_unavailable", "Estado indisponível", "Indisponível"],
  ] },
];

export const DEFAULT_TEXTS = Object.fromEntries(TEXT_GROUPS.flatMap((g) => g.items.map(([k, , v]) => [k, v])));
